import { render, staticRenderFns } from "./EventPrices.vue?vue&type=template&id=f8f28be2&scoped=true&"
import script from "./EventPrices.vue?vue&type=script&lang=ts&"
export * from "./EventPrices.vue?vue&type=script&lang=ts&"
import style0 from "./EventPrices.vue?vue&type=style&index=0&id=f8f28be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f28be2",
  null
  
)

export default component.exports